<template>
  <div class="row">
    <div class="match flex-center">
      <div class="grid-left">
        <match-info :id-match="idMatch" />
      </div>
      <div class="grid-right">
        <match-bets :id-match="idMatch" />
      </div>
    </div>
  </div>
</template>

<script>
import MatchInfo from './MatchInfo.vue';
import MatchBets from './MatchBets.vue';

export default {
  name: 'Match',
  components: {
    MatchInfo,
    MatchBets,
  },
  props: {
    idMatch: {
      required: true,
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.row .match {
  height: 100%;
  color: $color-text-primary;
  background-color: $match-color-back;

  /deep/ {
    .match-name:before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      content: "";
      width: 20px;
      background: linear-gradient(to right, rgba($match-color-back, 0), $match-color-back);
      z-index: 1;
    }
  }
}

.row:nth-child(odd) .match {
  background-color: $match-color-back-even;

  /deep/ {
    .match-display-id {
      background-color: $match-id-even-color-back;
    }

    .match-name:before {
      background: linear-gradient(to right,
        rgba($match-color-back-even, 0), $match-color-back-even);
    }
  }
}
</style>
